function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "FAB_-_Whats",
  "data-name": "FAB - Whats",
  transform: "translate(-1540.414 -777.119)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 1540.41, 777.12)",
  filter: "url(#Caminho_4206)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4206-2",
  "data-name": "Caminho 4206",
  d: "M-20566.088-17532.2l5.234-2.752,4.014,2.752h12.912l4.887-3.443,4.361-3.443,1.918-3.441,1.57-4.646v-8.264l-.873-4.129-1.744-2.408-2.791-2.75-2.441-2.07-4.887-3.1-3.664-.861h-4.363l-4.885.861-2.619,1.895-3.838,1.2-2.791,3.27-4.361,5.682-1.051,3.959v4.3l1.051,5.678,2.613,3.447v2.576l-1.395,2.932v1.889Z",
  transform: "translate(20589.5 17582.75)",
  fill: "#008f0f"
})), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4207",
  "data-name": "Caminho 4207",
  d: "M25.142,2A22.923,22.923,0,0,0,5.286,36.35L2.05,48.231l12.136-3.19A22.912,22.912,0,1,0,25.142,2m.023,3.86a19.047,19.047,0,0,1-.023,38.094A18.73,18.73,0,0,1,15.457,41.3l-.693-.393L7.552,42.8,9.47,35.772l-.462-.74A19.049,19.049,0,0,1,25.166,5.86m-8.137,8.46a2.112,2.112,0,0,0-1.526.717,6.562,6.562,0,0,0-2.011,4.785c0,2.82,2.057,5.525,2.312,5.918.324.393,4.068,6.172,9.824,8.622a24.962,24.962,0,0,0,3.259,1.225,7.919,7.919,0,0,0,3.606.231c1.11-.162,3.375-1.387,3.86-2.728a4.817,4.817,0,0,0,.347-2.728c-.162-.231-.532-.37-1.11-.624-.578-.324-3.4-1.711-3.907-1.9-.532-.185-.855-.277-1.294.277-.37.578-1.479,1.872-1.8,2.242-.347.393-.67.439-1.225.162a15.642,15.642,0,0,1-4.623-2.843,17.49,17.49,0,0,1-3.19-3.976A.877.877,0,0,1,19.8,22.55a7.632,7.632,0,0,0,.855-1.017,3.368,3.368,0,0,0,.578-.948,1.061,1.061,0,0,0-.046-.994c-.139-.254-1.294-3.121-1.78-4.253-.462-1.11-.925-.971-1.294-.994C17.792,14.344,17.422,14.321,17.029,14.321Z",
  transform: "translate(1554.27 784)",
  fill: "#fff"
}));

function SvgFabWhats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 76.309 74.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFabWhats);
export default __webpack_public_path__ + "static/media/FAB-Whats.82960b42.svg";
export { ForwardRef as ReactComponent };